import React from 'react';

const IDENTITIES = {
  adventure:   { label: 'The Adventurer',  emoji: '⚔️', color: '#e67e22', bg: 'rgba(230,126,34,0.12)', border: 'rgba(230,126,34,0.3)' },
  magic:       { label: 'The Dreamer',     emoji: '🔮', color: '#9b59b6', bg: 'rgba(155,89,182,0.12)', border: 'rgba(155,89,182,0.3)' },
  animals:     { label: 'Animal Friend',   emoji: '🦋', color: '#27ae60', bg: 'rgba(39,174,96,0.12)',  border: 'rgba(39,174,96,0.3)' },
  space:       { label: 'Space Explorer',  emoji: '🚀', color: '#2980b9', bg: 'rgba(41,128,185,0.12)', border: 'rgba(41,128,185,0.3)' },
  ocean:       { label: 'Ocean Explorer',  emoji: '🌊', color: '#1abc9c', bg: 'rgba(26,188,156,0.12)', border: 'rgba(26,188,156,0.3)' },
  funny:       { label: 'The Comedian',    emoji: '😄', color: '#f39c12', bg: 'rgba(243,156,18,0.12)', border: 'rgba(243,156,18,0.3)' },
  mystery:     { label: 'The Detective',   emoji: '🔍', color: '#7f8c8d', bg: 'rgba(127,140,141,0.12)',border: 'rgba(127,140,141,0.3)' },
  friendship:  { label: 'Heart of Gold',   emoji: '💛', color: '#f1c40f', bg: 'rgba(241,196,15,0.12)', border: 'rgba(241,196,15,0.3)' },
  educational: { label: 'The Scholar',     emoji: '📚', color: '#3498db', bg: 'rgba(52,152,219,0.12)', border: 'rgba(52,152,219,0.3)' },
  cozy:        { label: 'The Homebody',    emoji: '🏡', color: '#e74c3c', bg: 'rgba(231,76,60,0.12)',  border: 'rgba(231,76,60,0.3)' },
};

const getIdentity = (favoriteGenre) => {
  if (!favoriteGenre) return null;
  const key = favoriteGenre.toLowerCase().trim();
  return IDENTITIES[key] || { label: 'Story Lover', emoji: '📖', color: '#6f42c1', bg: 'rgba(111,66,193,0.12)', border: 'rgba(111,66,193,0.3)' };
};

export default function ChildIdentityBadge({ childName, favoriteGenre, compact = false }) {
  const identity = getIdentity(favoriteGenre);
  if (!identity) return null;

  if (compact) {
    return (
      <span className="badge rounded-pill d-inline-flex align-items-center gap-1"
        style={{ background: identity.bg, color: identity.color, border: `1px solid ${identity.border}`, fontSize: '12px', padding: '4px 10px', fontWeight: 600 }}>
        {identity.emoji} {identity.label}
      </span>
    );
  }

  return (
    <div className="d-flex align-items-center gap-3 p-3 rounded-4"
      style={{ background: identity.bg, border: `1px solid ${identity.border}` }}>
      <div style={{ fontSize: '36px', flexShrink: 0 }}>{identity.emoji}</div>
      <div>
        <div className="fw-bold" style={{ color: identity.color, fontFamily: "'Fredoka One',cursive", fontSize: '16px' }}>
          {childName} is {identity.label}
        </div>
        <div className="text-muted small">Based on their favourite stories</div>
      </div>
    </div>
  );
}
